import React, { useState } from 'react';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';
import { toast } from 'react-toastify';
import InputField from '../../../../../component/form/FormInput';
import { changeAccountStatus } from '../../../../../services/settings/accounting';

export default function DeactivateAccountReasonModal({
	isOpenModal,
	setIsOpenModal,
	accountId,
	getAccountDetails,
}) {
	const [reason, setReason] = useState('');
	const [error, setError] = useState(null);
	const [loader, setLoader] = useState(null);

	const handleDeactivateAccount = async () => {
		if (!reason || reason === undefined || reason === null || error !== null) {
			setError('Please filled reason for deactivate account');
			toast.error('Please filled reason for deactivate account');
			return;
		} else {
			try {
				setLoader(true);
				const data = {
					status: 0,
					reason: reason,
				};
				const res = await changeAccountStatus(accountId, data);
				if (res.success) {
					toast.success(res.message);
					setIsOpenModal(false);
					getAccountDetails();
				} else {
					toast.error(res.message || 'Something went wrong!');
				}
			} catch (error) {
			} finally {
				setLoader(false);
			}
		}
	};
	return (
		<Modal
			className="deactivate-account-modal"
			title={'Deactivate Account'}
			subtitle={'Please enter a reason for deactivating this account.'}
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div
				className="text-black fs-5 fw-semibold p-2"
				style={{ backgroundColor: '#E6F5FF' }}
			>
				Note: After deactivation, this account will not be available in new transactions. Old
				transactions and reports will remain unchanged.
			</div>
			<div className="col-12 p-2">
				<InputField
					type="text"
					value={reason}
					placeholder="Enter reason for deactivation"
					label="Reason"
					multiline={true}
					rows={4}
					onChange={(value) => {
						if (value) {
							setError(null);
						} else {
							setError('Please filled reason for deactivate account');
						}
						setReason(value);
					}}
					error={error}
					autoComplete="off"
				/>
			</div>
			<div className="d-flex align-items-center justify-content-end mt-4 gap-4">
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
				<Button
					type="button"
					button={`Deactivate`}
					className="mt-0 px-4 btn-primary relative"
					disabled={loader}
					loader={loader}
					onClick={() => handleDeactivateAccount()}
				/>
			</div>
		</Modal>
	);
}
